import { ReactNode } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faFile, faVideo } from '@fortawesome/pro-light-svg-icons'

import { Box, Image, Text } from '@domain-group/suit-theme'

import { getAttachmentType } from '@functions/attachment'

import Overlay from '@components/Overlay'

import type { AttachmentModel } from '@models/types'

interface AttachmentTileProps {
  attachment: AttachmentModel,
  callbacks?: {
    selectAttachment: () => void,
  },
  disabled?: boolean,
  children?: ReactNode,
  isSelected?: boolean,
}

export const AttachmentTile = (props: AttachmentTileProps) => {
  const {
    attachment, callbacks, children, disabled, isSelected,
  } = props

  const { selectAttachment } = callbacks || {}
  const isClickable = !!selectAttachment && !disabled

  const {
    data,
    file_file_name: fileName,
    id,
    links,
  } = attachment

  const { outdated } = data || {}

  const attachmentType = getAttachmentType(attachment)

  const imageUrl = links?.original_url

  return (
    <Box
      display="flex"
      onClick={isClickable ? () => selectAttachment() : undefined}
      position="relative"
      style={{
        cursor: isClickable ? 'pointer' : 'auto',
        opacity: isClickable && !isSelected ? 0.6 : 1,
      }}
    >
      {outdated && (
        <Overlay>
          <FontAwesomeIcon color="white" icon={faClock} />

          <Text color="white" marginTop="medium">Old Version</Text>
        </Overlay>
      )}

      {attachmentType === 'image' && (
        <Image
          borderRadius="5px"
          url={imageUrl}
        />
      )}

      {attachmentType !== 'image' && (
        <Box
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          textAlign="center"
          variant="whiteGrey"
        >
          <FontAwesomeIcon icon={attachmentType === 'video' ? faVideo : faFile} />

          <Box flexDirection="column" width="80%">
            <Text color="bodyFontColor" fontSize="small" marginTop="medium" variant="ellipsis">
              {fileName}
            </Text>

            <Text color="bodyFontLightColor" fontSize="small" marginTop="small">#{id}</Text>
          </Box>
        </Box>
      )}

      {/* Usecase is an overlay */}
      {children}
    </Box>
  )
}

export default AttachmentTile
